module.exports = __webpack_public_path__ + "static/img/PT@2x.f6c23d0f.jpg";